export default __webpack_public_path__ + "img/4-1-75be6283.png";